import {
  getUserProfileFailure,
  getUserProfileRequest,
  getUserProfileSuccess,
  connectInititativeRequest,
  connectInititativeSuccess,
  connectInititativeFailure,
  setNeedToLinkInitiative,
} from './actionCreator';

import { connectInitiativeById, getProfile } from './api.service';

export const getUserProfile =
  (initiativeId = sessionStorage.getItem('initiative_id')) =>
  async (dispatch) => {
    dispatch(getUserProfileRequest());
    try {
      const { data } = await getProfile({ initiative_id: String(initiativeId) });
      localStorage.setItem('user', JSON.stringify(data.data));
      localStorage.setItem('permissions', JSON.stringify(data.data.permissions));
      dispatch(getUserProfileSuccess(data.data));
    } catch ({ message }) {
      dispatch(getUserProfileFailure(message));
    }
  };

export const updateNeedToLinkInitiative = (userId) => async (dispatch) => {
  if (userId) localStorage.setItem('userIdForLinkNewInitiative', userId);
  if (!userId) localStorage.removeItem('userIdForLinkNewInitiative');
  dispatch(setNeedToLinkInitiative(userId));
};

export const connectInitiative = (userId) => async (dispatch) => {
  dispatch(connectInititativeRequest());
  try {
    const { data } = await connectInitiativeById(userId);
    dispatch(connectInititativeSuccess(data));
    dispatch(updateNeedToLinkInitiative(null));
  } catch ({ message }) {
    dispatch(connectInititativeFailure(message));
  }
};
